(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-wallet-main-visual-refined"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cm-wallet-refined')) {
    customElements.define('cm-wallet-refined', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.playButton = this.querySelector('[data-play]');
        this.current = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
        this.requested = this.current;
        this.requestVersion = 0;
        this.pending = false;
        this.currentReady = false;
        this.interval = Math.max(3000, Number(this.dataset.interval) || 6000);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
        this.hovering = false;
        this.focused = false;
        this.editing = false;
        this.touchPointers = new Set();
        this.gesture = null;
        this.suppressClickUntil = 0;
        if (this.slides.length < 2) return;
        const stage = this.querySelector('.cm-wrf__stage');
        stage.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch' || !event.isPrimary || this.touchPointers.size) return;
          this.suppressClickUntil = 0;
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, axis: null, threshold: Math.max(40, Math.min(80, stage.clientWidth * .12)) };
          this.schedule();
        }, { signal });
        window.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch') return;
          this.touchPointers.add(event.pointerId);
          if (this.touchPointers.size > 1 && this.gesture) this.gesture.axis = 'cancelled';
        }, { signal });
        window.addEventListener('pointermove', event => this.trackGesture(event), { signal, passive: true });
        window.addEventListener('pointerup', event => this.finishGesture(event, false), { signal });
        window.addEventListener('pointercancel', event => this.finishGesture(event, true), { signal });
        stage.addEventListener('click', event => {
          if (event.detail === 0 || Date.now() > this.suppressClickUntil) return;
          event.preventDefault();
          event.stopPropagation();
        }, { signal, capture: true });
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.requested - 1, true), { signal });
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.requested + 1, true), { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true), { signal }));
        this.playButton.addEventListener('click', () => { this.playing = !this.playing; if (this.playing) { this.focused = false; this.hovering = false; } this.updatePlayback(); }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.requested + (event.key === 'ArrowLeft' ? -1 : 1), true);
        }, { signal });
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovering = true; this.schedule(); } }, { signal });
        this.addEventListener('pointerleave', () => { this.hovering = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); }), { signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden && this.currentReady) this.preloadNext();
          this.schedule();
        }, { signal });
        this.motion.addEventListener('change', event => { if (event.matches) this.playing = false; this.updatePlayback(); }, { signal });
        this.slides.forEach((slide, index) => {
          const image = slide.querySelector('img');
          if (!image) return;
          image.addEventListener('load', () => {
            if (this.currentReady || this.pending || this.current !== index) return;
            const session = this.controller;
            const version = this.requestVersion;
            this.prepareImage(index, false, session).then(ok => {
              if (!ok || !this.isConnected || this.controller !== session || this.requestVersion !== version || this.current !== index) return;
              this.currentReady = true;
              if (index === 0) this.slides[index].classList.remove('cm-wrf__slide--preview');
              this.preloadNext();
              this.schedule();
            });
          }, { signal });
        });
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.editing = true;
          this.show(index, false, true);
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail?.blockId)) return;
          this.editing = false;
          this.schedule();
        }, { signal });
        this.updatePlayback();
        const session = this.controller;
        const initialVersion = this.requestVersion;
        const initialIndex = this.current;
        const initialReady = () => this.restoreInitialReady(initialIndex, session, initialVersion);
        this.prepareImage(initialIndex, false, session, initialReady).then(ok => {
          if (ok) initialReady();
        });
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.requestVersion++;
        this.controller?.abort();
        this.controller = null;
        this.gesture = null;
        this.touchPointers?.clear();
        this.suppressClickUntil = 0;
      }
      trackGesture(event) {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id || gesture.axis === 'cancelled') return;
        const x = Math.abs(event.clientX - gesture.x);
        const y = Math.abs(event.clientY - gesture.y);
        if (!gesture.axis && Math.max(x, y) >= 10) gesture.axis = x > y * 1.5 ? 'horizontal' : 'cancelled';
      }
      finishGesture(event, cancelled) {
        this.touchPointers.delete(event.pointerId);
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        this.trackGesture(event);
        this.gesture = null;
        const x = event.clientX - gesture.x;
        const y = event.clientY - gesture.y;
        if (!cancelled && gesture.axis === 'horizontal') {
          this.suppressClickUntil = Date.now() + 500;
          if (Math.abs(x) >= gesture.threshold && Math.abs(x) > Math.abs(y) * 1.5) {
            this.show(this.requested + (x < 0 ? 1 : -1), true);
            return;
          }
        }
        this.schedule();
      }
      restoreInitialReady(index, session, version) {
        if (!this.isConnected || this.controller !== session || this.requestVersion !== version || this.current !== index || this.pending) return;
        this.currentReady = true;
        if (index === 0) this.slides[index].classList.remove('cm-wrf__slide--preview');
        this.preloadNext();
        this.schedule();
      }
      prepareImage(index, retry, session, onLateReady) {
        const image = this.slides[index]?.querySelector('img');
        if (!image) return Promise.resolve(true);
        return new Promise(resolve => {
          let finished = false;
          let timedOut = false;
          let decoding = false;
          const cleanup = () => {
            clearTimeout(timeout);
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
            session.signal.removeEventListener('abort', onAbort);
          };
          const finish = ok => {
            if (finished) return;
            finished = true;
            cleanup();
            resolve(ok);
          };
          const onAbort = () => finish(false);
          const onError = () => finish(false);
          const onLoad = () => {
            if (finished || decoding || !image.complete || !image.naturalWidth) return;
            decoding = true;
            const source = image.currentSrc;
            const decoded = typeof image.decode === 'function' ? Promise.resolve().then(() => image.decode()) : Promise.resolve();
            Promise.resolve(decoded).then(() => {
              decoding = false;
              if (finished) {
                if (timedOut && image.currentSrc === source && image.complete && image.naturalWidth && onLateReady) onLateReady();
                return;
              }
              if (image.currentSrc !== source) {
                if (image.complete && image.naturalWidth) onLoad();
                return;
              }
              finish(!!image.naturalWidth);
            }, () => {
              decoding = false;
              if (finished) return;
              if (image.currentSrc !== source) {
                if (image.complete && image.naturalWidth) onLoad();
              } else {
                finish(false);
              }
            });
          };
          const timeout = setTimeout(() => { timedOut = true; finish(false); }, 30000);
          image.addEventListener('load', onLoad);
          image.addEventListener('error', onError);
          session.signal.addEventListener('abort', onAbort, { once: true });
          image.loading = 'eager';
          if (session.signal.aborted) { finish(false); return; }
          if (image.complete && image.naturalWidth) {
            onLoad();
          } else if (retry && image.complete && image.currentSrc) {
            const src = image.getAttribute('src');
            if (src) image.setAttribute('src', src);
          }
        });
      }
      show(index, announce, editorSelection = false) {
        if (!this.isConnected) return;
        const target = ((index % this.slides.length) + this.slides.length) % this.slides.length;
        const version = ++this.requestVersion;
        const session = this.controller;
        this.requested = target;
        this.pending = true;
        this.schedule();
        if (editorSelection) {
          this.currentReady = false;
          this.commitSlide(target, announce);
        }
        this.prepareImage(target, true, session).then(ok => {
          if (!this.isConnected || this.controller !== session || this.requestVersion !== version) return;
          this.pending = false;
          if (ok) {
            this.currentReady = true;
            if (target === 0) this.slides[target].classList.remove('cm-wrf__slide--preview');
            if (!editorSelection) this.commitSlide(target, announce);
            this.preloadNext();
          } else {
            this.requested = this.current;
            this.playing = false;
            this.updatePlayback();
            if (!this.currentReady) {
              const current = this.current;
              this.prepareImage(current, false, session).then(currentOk => {
                if (!currentOk || !this.isConnected || this.controller !== session || this.requestVersion !== version || this.pending || this.current !== current) return;
                this.currentReady = true;
                if (current === 0) this.slides[current].classList.remove('cm-wrf__slide--preview');
                this.preloadNext();
                this.schedule();
              });
            }
          }
          this.schedule();
        });
      }
      commitSlide(index, announce) {
        this.current = index;
        this.slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== index; });
        this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-pressed', String(dotIndex === index)));
        this.querySelector('[data-current]').textContent = String(index + 1);
        if (announce) this.querySelector('[data-announcement]').textContent = this.slides[index].getAttribute('aria-label');
      }
      preloadNext() {
        if (!this.currentReady || !this.isConnected || document.hidden) return;
        const image = this.slides[(this.current + 1) % this.slides.length]?.querySelector('img');
        if (image) image.loading = 'eager';
      }
      updatePlayback() {
        if (!this.playButton) return;
        this.playButton.textContent = this.playing ? 'Ⅱ 停止' : '▷ 再生';
        this.playButton.setAttribute('aria-label', this.playing ? '自動切り替えを停止' : '自動切り替えを再生');
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.playing || !this.currentReady || this.pending || document.hidden || this.hovering || this.focused || this.editing || this.gesture || this.slides.length < 2) return;
        this.timer = setTimeout(() => this.show(this.current + 1, false), this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
